import type { SpinnerProps } from "react-bootstrap";

import { Spinner as BsSpinner } from "react-bootstrap";

export interface ILoadingProps extends Omit<SpinnerProps, "size"> {
  size?: "sm" | "lg";
}

function Loading({
  variant = "secondary",
  animation = "border",
  size = "sm",
  ...props
}: ILoadingProps) {
  const isStandardSize = size === "sm";

  return (
    <BsSpinner
      role="status"
      animation={animation}
      variant={variant}
      size={isStandardSize ? "sm" : undefined}
      {...props}
    >
      <span className="visually-hidden">Loading...</span>
    </BsSpinner>
  );
}

export default Loading;
